<template>
  <detail-layout>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off" >
          <div class="flex-1">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
              <el-form-item prop="LocationName">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.LocationName"
                  maxlength='40'
                  :disabled="isRoleUserOrConsulta"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('tipos.metadata.envio') }}</label>
              <el-form-item prop="SendType">
                <el-select class="w-full" 
                  v-model="form.SendType" 
                  clearable
                  filterable
                  :disabled="isRoleUserOrConsulta">
                  <el-option
                    v-for="opt in tiposFormasEnvio"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $tc('agenda.rol' ,2) }}</label>
              <el-form-item prop="LocationRoles">
                <el-select class="w-full" 
                  v-model="form.LocationRoles" 
                  multiple
                  clearable
                  filterable
                  :disabled="isRoleUserOrConsulta">
                  <el-option
                    v-for="opt in tiposRolAgenda"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <base-collapsible-form
              v-if="form.SendType === 'FACEB2B'"
              ref="baseCollapsibleFACEB2B"
              class="mt-2 mb-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('administrativecenter.data_faceb2b') }}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
                  <el-form-item prop="Name">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Name"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('companies.configuration_rec.dire') }}</label>
                  <el-form-item prop="DIRE">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.DIRE"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form
              ref="baseCollapsibleRegistrationAddress"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('address.header')}}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.location') }}</label>
                  <el-form-item prop="Address">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Address"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.codigo_postal') }}
                  </label>
                  <el-form-item prop="PostCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.PostCode"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.poblacion') }}
                  </label>
                  <el-form-item prop="Town">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Town"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.provincia') }}
                  </label>
                  <el-form-item prop="Province">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Province"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.pais') }}</label>
                  <el-form-item prop="CountryCode">
                    <el-select class="w-full" 
                      v-model="form.CountryCode" 
                      filterable
                      clearable 
                      :placeholder="$t('app.select')"
                      :disabled="isRoleUserOrConsulta">
                      <el-option
                        v-for="opt in listPaises"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
            <base-collapsible-form
              ref="baseCollapsibleRegistrationData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.ContactDetails')}}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
                  <el-form-item prop="Telephone">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Telephone"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.telefax') }}</label>
                  <el-form-item prop="TeleFax">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.TeleFax"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.WebAddress') }}</label>
                  <el-form-item prop="WebAddress">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.WebAddress"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ElectronicMail') }}</label>
                  <el-form-item prop="ElectronicMail">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ElectronicMail"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ContactPersons') }}</label>
                  <el-form-item prop="ContactPersons">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ContactPersons"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.CnoCnae') }}</label>
                  <el-form-item prop="CnoCnae">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.CnoCnae"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.INETownCode') }}</label>
                  <el-form-item prop="INETownCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.INETownCode"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.AdditionalContactDetails') }}</label>
                  <el-form-item prop="AdditionalDetails">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.AdditionalDetails"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
  </detail-layout>
</template>

<script>

import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'

import DetailLayout from '@/components/layout/DetailLayout.vue'

export default {
  name: 'detalle-sede',
  components: {
    DetailLayout,
  },
  props: {
    form: {
      type: Object,
    },
  },
  data: function () {
    return {
      rules: {
        LocationName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        SendType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        LocationRoles: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Address: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Town: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Province: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CountryCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        PostCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
        ElectronicMail: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        DIRE: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CnoCnae: [
          {
            required: false,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
      },
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    }, 
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    tiposFormasEnvio: function () {
      // Hay elementos duplicados 
      const sendType = new Set(this.$store.getters['config/TIPOS_PGE'].concat(this.$store.getters['config/TIPOS_PGE_RECEPCION']).map(JSON.stringify))
      return Array.from(sendType).map(JSON.parse)
    },
    tiposRolAgenda: function () {
      return this.$store.getters['config/TIPOS_ROL_AGENDA']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
  },
  mounted () {
    this.$refs.baseCollapsibleRegistrationAddress.toggle()
  },
  methods: {
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback() // Campo opcional
      }
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    resetForm: function () {
      this.$refs.ruleForm.resetForm()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        callback(valid)
      })
    },
  },
}
</script>

<style>

</style>
